export class Institution {
  static fromJSON(newInstitution: Institution): Institution {
    const o: Institution = Object.assign(new Institution(), newInstitution);
    return o;
  }

  public id = 0;
  public name = "";
  public created_at: Date = new Date();
  public updated_at: Date = new Date();
  public municipality_id = 0;
  public institution_type_id = 0;
  public address = "";
  public postal_district_id: number | null = null;
  public code: number | null = null;
  public subscription_agreement_read_by_id: number | null = null;
  public subscription_agreement_date_of_acceptance: Date | null = null;
  public show_double_duty_button = false;
  public email_address = "";
  public show_segments = false;
  public has_school_hours = false;
  public market = "dk";
  public salary_system = 0;
  public salary_institution_code = "";
  public salary_period_end_day = 0;
  public uses_children_data_sharing = false;
  public is_public = false;
  public school_id = 0;
  public school_time_schedule_id = 0;
  public active = false;
  public st_inside_at_on_web_accept_for_ok13 = false;
  public st_subtracts_from_pool_for_ok13 = false;
  public so_calculates_as = 0;
  public so_changed_by = "";

  equals(other: Institution): boolean {
    return other.id === this.id;
  }
}
